<template>
  <div>
    <!-- PC 端：Flex 左右布局 -->
    <div v-if="showHeaderAndSidebar && !isMobile" class="pc-layout">
      <!-- 侧边栏 -->
      <Sidebar
        :isCollapsed="isMenuCollapsed"
        @toggleMenu="toggleMenu"
      />
      <!-- 主内容区 -->
      <div class="main-container">
        <Header
          :username="username"
          :isOnline="isOnline"
          @logout="logout"
          @toggleMenu="toggleMenu"
        />
        <main>
          <router-view />
        </main>
      </div>
    </div>

    <!-- 手机端：无侧边栏，使用底部导航栏 -->
    <div v-else-if="showHeaderAndSidebar" class="mobile-layout">
      <Header
        :username="username"
        :isOnline="isOnline"
        @logout="logout"
        @toggleMenu="toggleMenu"
      />
      <main class="mobile-main">
        <router-view />
      </main>
      <BottomNav />
    </div>

    <!-- 未登录 -->
    <div v-else>
      <router-view />
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, computed } from "vue";
import Header from "./components/PageHeader.vue";
import Sidebar from "./components/PageSidebar.vue";
import BottomNav from "./components/BottomNav.vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: { Header, Sidebar, BottomNav },
  setup() {
    const router = useRouter();
    const store = useStore();

    const isMenuCollapsed = ref(false);
    const username = ref("管理员");
    const isOnline = ref(true);
    const showHeaderAndSidebar = ref(false);
    const windowWidth = ref(window.innerWidth);

    const isMobile = computed(() => windowWidth.value <= 768);

    const toggleMenu = () => {
      isMenuCollapsed.value = !isMenuCollapsed.value;
    };

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      const loggedIn = localStorage.getItem("loggedIn");
      if (loggedIn) showHeaderAndSidebar.value = true;
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    const logout = () => {
      localStorage.removeItem("loggedIn");
      store.dispatch("logout");
      router.push("/login");
      window.location.reload();
    };

    return {
      isMenuCollapsed,
      username,
      isOnline,
      toggleMenu,
      showHeaderAndSidebar,
      logout,
      isMobile,
      windowWidth,
    };
  },
};
</script>

<style>
/* 全局重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: "Inter", system-ui, -apple-system, sans-serif;
  background: #f8fafc;
}

/* PC 端 Flex 布局 */
.pc-layout {
  display: flex;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

/* 主内容区：flex 自动占满剩余宽度 */
.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f8fafc;
  min-width: 0; /* 防止 flex 子项溢出 */
}

/* Header 区域（可选） */
.pc-layout .header {
  flex-shrink: 0;
}

/* 主要内容滚动区 */
main {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

/* 手机端布局 */
.mobile-layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f8fafc;
}

.mobile-main {
  flex: 1;
  overflow-y: auto;
  padding: 0px;
  padding-bottom: 80px; /* 为底部导航栏留出空间 */
}

/* 滚动条美化 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>